import React, { Component } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';

class Table extends Component {
  static propTypes = {
    header: PropTypes.array.isRequired,
    rows: PropTypes.array.isRequired,
    className: PropTypes.any
  };

  getSizeSpec = (size) => {
    if (typeof(size) === 'string' && size.substr(size.length - 1, 1) === '%') {
      return { style: { maxWidth: size } };
    }
    return { md: size };
  }

  render() {
    return (
      <Container className={'codai-table '+ this.props.className}>
        <Row className='table-header'>
          { this.props.header.map((h, i) => (
            <Col
              key={i}
              className={'table-header-item' + (i == (this.props.header.length - 1) ? ' table-header-item-last': '')}
              {...this.getSizeSpec(h.size)}
              >
                {h.content}
            </Col>
          ))}
        </Row>
        { this.props.rows.map((r, i) => (
          <Row key={i} {...r.rowProps} className={'table-row' + ((r.rowProps && r.rowProps.className) ? (' ' + r.rowProps.className) : '')}>
            { r.cells.map((c, j) => (
              <Col
                key={j}
                className={'table-row-cell' + (j == (r.cells.length - 1) ? ' table-row-cell-last': '')}
                {...this.getSizeSpec(this.props.header[j].size)}
                >
                  {c}
              </Col>
            ))}
          </Row>
        ))}
      </Container>
    );
  }
}

export default Table;
